import type { Realtor } from '../types/portal'

/**
 * Realtor and partner accounts are shared across the whole database to prevent
 * duplicates. "My Realtors" is derived from communications this loan officer
 * has logged, not from record ownership.
 */
export const realtors: Realtor[] = [
  {
    id: 'A-2188',
    name: 'Curtis Nakamura',
    company: 'Keller Williams',
    partnerType: 'Realtor',
    phone: '(303) 555-0211',
    email: 'curtis.nakamura@example.com',
    market: 'Denver Metro',
    daysSinceMyTouch: 12,
    lastTouchLabel: 'Call logged 12 days ago',
    lastChannel: 'call',
    sharedBuyers: 1,
    referralsYtd: 4,
    access: 'open',
    otherOfficersActive: 1,
  },
  {
    id: 'A-2140',
    name: 'Hannah Pierce',
    company: 'Berkshire Hathaway HomeServices',
    partnerType: 'Realtor',
    phone: '(720) 555-0243',
    email: 'hannah.pierce@example.com',
    market: 'Cherry Creek',
    daysSinceMyTouch: 15,
    lastTouchLabel: 'In-person visit logged 15 days ago',
    lastChannel: 'in-person',
    sharedBuyers: 2,
    referralsYtd: 11,
    access: 'open',
    otherOfficersActive: 0,
  },
  {
    id: 'A-2201',
    name: 'Dana Whitfield',
    company: 'Compass',
    partnerType: 'Realtor',
    phone: '(303) 555-0287',
    email: 'dana.whitfield@example.com',
    market: 'Denver Metro',
    daysSinceMyTouch: 9,
    lastTouchLabel: 'Email logged 9 days ago',
    lastChannel: 'email',
    sharedBuyers: 3,
    referralsYtd: 7,
    access: 'open',
    otherOfficersActive: 2,
  },
  {
    id: 'A-2165',
    name: 'Sofia Delgado',
    company: 'Coldwell Banker',
    partnerType: 'Realtor',
    phone: '(720) 555-0298',
    email: 'sofia.delgado@example.com',
    market: 'Highlands Ranch',
    daysSinceMyTouch: 8,
    lastTouchLabel: 'Call logged 8 days ago',
    lastChannel: 'call',
    sharedBuyers: 4,
    referralsYtd: 6,
    access: 'open',
    otherOfficersActive: 1,
  },
  {
    id: 'A-2176',
    name: 'Renee Ortiz',
    company: 'RE/MAX Alliance',
    partnerType: 'Realtor',
    phone: '(303) 555-0166',
    email: 'renee.ortiz@example.com',
    market: 'Lakewood',
    daysSinceMyTouch: 0,
    lastTouchLabel: 'Call logged today 8:20 AM',
    lastChannel: 'call',
    sharedBuyers: 2,
    referralsYtd: 5,
    access: 'open',
    otherOfficersActive: 0,
  },
  {
    id: 'A-2151',
    name: 'Wes Cardoza',
    company: 'Redfin',
    partnerType: 'Realtor',
    phone: '(720) 555-0121',
    email: 'wes.cardoza@example.com',
    market: 'Aurora',
    daysSinceMyTouch: 3,
    lastTouchLabel: 'Text logged 3 days ago',
    lastChannel: 'text',
    sharedBuyers: 1,
    referralsYtd: 2,
    access: 'open',
    otherOfficersActive: 0,
  },
  {
    id: 'A-2170',
    name: 'Trent Mabry',
    company: 'eXp Realty',
    partnerType: 'Realtor',
    phone: '(303) 555-0139',
    email: 'trent.mabry@example.com',
    market: 'Arvada',
    daysSinceMyTouch: 4,
    lastTouchLabel: 'Email logged 4 days ago',
    lastChannel: 'email',
    sharedBuyers: 0,
    referralsYtd: 0,
    access: 'open',
    otherOfficersActive: 1,
  },
  {
    id: 'A-2094',
    name: 'Kimberly Vance',
    company: 'Vista Reach Realty (House account)',
    partnerType: 'Realtor',
    phone: '(305) 555-0180',
    email: 'kimberly.vance@example.com',
    market: 'South Florida',
    daysSinceMyTouch: null,
    lastTouchLabel: null,
    lastChannel: null,
    sharedBuyers: 0,
    referralsYtd: 38,
    access: 'house-locked',
    otherOfficersActive: 4,
  },
  {
    id: 'A-2088',
    name: 'Terry Bayhall',
    company: 'Bayhall Group (House account)',
    partnerType: 'Realtor',
    phone: '(954) 555-0144',
    email: 'terry.bayhall@example.com',
    market: 'South Florida',
    daysSinceMyTouch: null,
    lastTouchLabel: null,
    lastChannel: null,
    sharedBuyers: 0,
    referralsYtd: 52,
    access: 'house-locked',
    otherOfficersActive: 6,
  },
  {
    id: 'A-2077',
    name: 'Nickley Realty Group',
    company: 'Nickley Group (House account)',
    partnerType: 'Realtor',
    phone: '(614) 555-0117',
    email: 'partners@nickleygroup.example.com',
    market: 'National',
    daysSinceMyTouch: null,
    lastTouchLabel: null,
    lastChannel: null,
    sharedBuyers: 0,
    referralsYtd: 84,
    access: 'house-locked',
    otherOfficersActive: 9,
  },
  {
    id: 'P-3310',
    name: 'Alan Reyes-Duffy',
    company: 'Summit Title Partners',
    partnerType: 'Title',
    phone: '(303) 555-0311',
    email: 'alan.duffy@example.com',
    market: 'Denver Metro',
    daysSinceMyTouch: 6,
    lastTouchLabel: 'Coffee meeting logged 6 days ago',
    lastChannel: 'in-person',
    sharedBuyers: 0,
    referralsYtd: 3,
    access: 'open',
    otherOfficersActive: 2,
  },
  {
    id: 'P-3325',
    name: 'Bianca Ostrowski',
    company: 'Foothills Insurance Advisors',
    partnerType: 'Insurance',
    phone: '(720) 555-0327',
    email: 'bianca.o@example.com',
    market: 'Denver Metro',
    daysSinceMyTouch: 22,
    lastTouchLabel: 'Call logged 22 days ago',
    lastChannel: 'call',
    sharedBuyers: 0,
    referralsYtd: 1,
    access: 'open',
    otherOfficersActive: 0,
  },
]
